import { render, staticRenderFns } from "./TeacherActiveLog.vue?vue&type=template&id=6bda4835&"
import script from "./TeacherActiveLog.vue?vue&type=script&lang=js&"
export * from "./TeacherActiveLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports